import { createFileRoute } from '@tanstack/react-router';
import { MatchPointsPage } from '@/features/debrief-v2';

export const Route = createFileRoute(
  '/_dashboard/interactions/debrief-v2/$id/match-points'
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  return <MatchPointsPage sessionId={id} />;
}
